export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7663.5aae6db3.jpg";